import './BuybackRippleWaves.css';

/**
 * Concentric expanding rings rendered behind the Buyback modal's
 * primary CTA — Figma 881:930. Each ring is a pill-shaped element
 * whose `box-shadow` spread expands outward from 0 to 32px while
 * fading to transparent, so the wave appears to RADIATE FROM the
 * button (not pulse around it). Three rings, staggered by ⅓ of the
 * cycle, keep the loop continuous.
 *
 * Wave colour = button fill. Pulled from `--co-Button-primaryFill`
 * (theme-constructor override) → `--ui-button` (partner-theme token)
 * → brand green as the final fallback. `color` on the host element
 * cascades into the rings' `currentColor` box-shadows.
 *
 * Pure decoration — `pointer-events-none` so clicks pass through to
 * the underlying Button. Sits absolutely inside a `relative` wrapper
 * around the CTA so the rings inherit the pill's box dimensions and
 * line up with its rounded edges.
 */
const WAVE_DELAYS = ['0s', '1.5s', '3s'] as const;

export function BuybackRippleWaves() {
  return (
    <div
      aria-hidden
      className="pointer-events-none absolute inset-0"
      style={{
        color:
          'var(--co-Button-primaryFill, var(--ui-button, #22E11C))',
      }}
    >
      {WAVE_DELAYS.map((delay) => (
        <span
          key={delay}
          className="buyback-wave absolute inset-0 rounded-full"
          style={{ animationDelay: delay }}
        />
      ))}
    </div>
  );
}
